import { AfterViewInit, Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { EnrollmentRentalPropertyLicense } from "../../../../../domain/model/enrollment/enrollmentRentalPropertyLicense";

@Component({
  selector: "app-rental-property-license",
  templateUrl: "./rental-property-license.component.html",
  styleUrl: "./rental-property-license.component.css",
})
export class RentalPropertyLicenseComponent implements AfterViewInit {
  @Input() rentalPropertyLicense!: FormGroup;
  @Input() providerOneLabel?: string;
  ngAfterViewInit(): void {
    setTimeout(() => {});
  }

  ngOnInit() {
   if(this.rentalPropertyLicense
    .get("taxCertificateNumber")?.value.length > 0){
      const value2 = this.rentalPropertyLicense.get("taxCertificateNumber")?.value.replace("-", "")
      .replace(/^(\d{2})(\d)/, "$1-$2") // Add the first dash after 2 digits
      .replace(/-(\d{10})(\d)/, "-$1-$2");
      this.rentalPropertyLicense.get("taxCertificateNumber")?.setValue(value2);
    }
    this.rentalPropertyLicense
      .get("departmentOfBusiness")
      ?.valueChanges.subscribe(() => {
        this.rentalPropertyLicense.get("departmentOfBusiness")?.markAsTouched();
      });
    this.rentalPropertyLicense
      .get("stateCertificateHasBeenApplied")
      ?.valueChanges.subscribe((value) => {
     
        if (
          value &&
          this.rentalPropertyLicense.get("taxCertificateNumber")?.enabled &&
          this.rentalPropertyLicense.get("reasonWhy")?.enabled
        ) { 
          this.rentalPropertyLicense.get("taxCertificateNumber")?.disable();
          this.rentalPropertyLicense.get("reasonWhy")?.disable();
        } else if (
          !value &&
          this.rentalPropertyLicense.get("taxCertificateNumber")?.disabled &&
          this.rentalPropertyLicense.get("reasonWhy")?.disabled
        ) {
          this.rentalPropertyLicense.get("taxCertificateNumber")?.enable();
          this.rentalPropertyLicense.get("reasonWhy")?.enable();
        }
      });
    this.rentalPropertyLicense
      .get("taxCertificateNumber")
      ?.valueChanges.subscribe((value) => {
      
        value = value.replace(/[^0-9\-]/g, "");
        this.rentalPropertyLicense.get("taxCertificateNumber")?.markAsTouched();

        if (value) { 
          value = value.replace(/[^0-9\-]/g, "");
          this.rentalPropertyLicense
            .get("stateCertificateHasBeenApplied")
            ?.disable();
          this.rentalPropertyLicense.get("reasonWhy")?.disable();
        } else if (
          !value &&
          this.rentalPropertyLicense.get("reasonWhy")?.disabled
        ) {
          this.rentalPropertyLicense
            .get("stateCertificateHasBeenApplied")
            ?.enable();
          this.rentalPropertyLicense.get("reasonWhy")?.enable();
        }
      });

      this.rentalPropertyLicense
      .get("reasonWhy")
      ?.valueChanges.subscribe((value) => {
      
        this.rentalPropertyLicense.get("reasonWhy")?.markAsTouched();

        if (value) { 
          this.rentalPropertyLicense
            .get("stateCertificateHasBeenApplied")
            ?.disable();
          this.rentalPropertyLicense.get("taxCertificateNumber")?.disable();
        } else if (
          !value &&
          this.rentalPropertyLicense.get("taxCertificateNumber")?.disabled &&
          this.rentalPropertyLicense.get("stateCertificateHasBeenApplied")?.disabled 
        ) {
          this.rentalPropertyLicense
            .get("stateCertificateHasBeenApplied")
            ?.enable();
          this.rentalPropertyLicense.get("taxCertificateNumber")?.enable();
        }
      });
  }

  saveInfo(): EnrollmentRentalPropertyLicense {
    let data: EnrollmentRentalPropertyLicense = {
      regulationLicenseNumber:
        this.rentalPropertyLicense?.get("departmentOfBusiness")?.value ?? "",
      certificateOfRegistration:
        this.rentalPropertyLicense?.get("cityOfRegistration")?.value ?? "",
      taxCertificateNumber:
        this.rentalPropertyLicense?.get("taxCertificateNumber")?.value ?? "",
      stateCertificateHasBeenApplied:
        this.rentalPropertyLicense?.get("stateCertificateHasBeenApplied")
          ?.value ?? false,
      taxReceipt: "",
      reasonWhy: this.rentalPropertyLicense?.get("reasonWhy")?.value ?? "",
    };
    return data;
  }
}
